module.exports = __webpack_public_path__ + "static/img/bg2.f05be6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg/bg2.jpg
// module id = 1206
// module chunks = 18